import React from 'react';
import {Collapse} from 'react-collapse';
import constants from '../constants';
import CoinUtils from '../util/CoinUtils';

// import SPUtilities from '../util/SPUtilities';

class NetworkUtils extends React.Component {

  static getDisclaimer() {
    return (<Collapse isOpened={true}>
          <ul>
            <li>This is an experimental dashboard that provides a view into decentralization related metrics for chains that Smart Stake participates in as a validator and has relevant data available. </li>
            <li>It is anticipated that the metrics will evolve over time based on community feedback/discussions.</li>
            <li>The metrics presented here are not a verdict on the state of decentralization in any network.</li>
            <li>Decentralization is a long journey and the metrics covered here are a small subset.</li>
            <li>Some of the metrics provided here have direct correlation with the degree of decentralization in the network.</li>
            <li>At the same time, some other metrics are captured to visualize how general network usage metric may (or may not) correlate with decentralization metrics</li>
            <li>What's next? build more metrics, finetune the existing metrics, capture/provide visualizations into how the metrics change over time.</li>
          </ul>
        </Collapse>);
  }

  static getScreenGuide() {
    return (<Collapse isOpened={true}>
          <ul><u>Decentralization Metrics:</u>
            <li>Gini Coefficient - Gini coefficient is a metric used to describe the level of inequality of stake between all validators. <a href={constants.urls.giniExplanation} target="_blank">Click here</a> for more explanation.</li>
            <li>Nakamoto Coefficient - Nakamoto coefficient is the number of top validators, holding together 34% of staked coins. Measures the prevalence of top validators comparing to the whole. <a href={constants.urls.nakamotoExplanation} target="_blank">Click here</a> for more explanation.</li>
            <li>Validators with majority power - The smallest number of validators that together control 67% of the voting power. Higher number is better from decentralization perspective.</li>
            <li>Validators below Average Voting Power - Numbers of validators below average voting power. Lower number (in comparison to total number of validators) is better. Higher number is better from decentralization perspective.</li>
            <li>Average Voting Power - Average of the voting power of each validator on the network</li>
            <li>Number of Validators - Total number of validators that are participating in the consensus in each chain. It does not include validators that are not considered elected/bonded.</li>
          </ul>
          <ul><u>Network Metrics</u> (not directly related to decentralization):
            <li>*Percent Staked - Percentage of the supply that is locked in staking. Some of the networks have non-circulating supply locked in staking. To keep the metric simple across all chains, the metric uses Total Supply in the calculation.</li>
            <li>Staking APR - expected returns from staking on the network. Based on chain specific methods of APR calculations. There may be some inaccuracies depending upon the specifics of a chain.</li>
            <li>Median Commission - Median value of the commission charged by all validators on the network.</li>
            <li>Weighted Median Commission - Weighted median of the commission charged by all validators.</li>
            <li>Unique Delegates - Total number of unique delegates/stakers.</li>
            <li>Unique Delegations - Total number of unique delegations from the delegates/stakers.</li>
          </ul>
        </Collapse>);
  }

  static networkFormatter(cell, row) {
    // return (<a href={SPUtilities.getUrl(row.website)} target="_blank" className="animLink">{cell}</a>);
    return (<a href={"/network/" + row.tokenSymbol} className="animLinkVisual">{cell}</a>);
  }

  static renderAnalytics(analyticsWebsite, row) {
    if (!analyticsWebsite || analyticsWebsite === "") {
      return "-";
    }
  
    const onClick = e => e.stopPropagation();
    return (<span onClick={ onClick }><a href={analyticsWebsite}
      target="_blank"><button className="animLink animLink linkBorder" id={"analytics" + row.symbol}
      >Analytics</button></a></span>);
  }

  static renderButton(label, link, newWindow) {
      if (newWindow) {
        return (
            <span className="delegateContainer centerAlign">
                <div className="miniStat">
                    <div className="miniStatTitle">
                    <span><a href={link}
                        target="_blank"><button className="animLink animLink linkBorder" id={label}
                        >{label}</button></a></span>
                    </div>
                </div>
            </span>
        );
      }

      return (
            <span className="delegateContainer centerAlign">
                <div className="miniStat">
                    <div className="miniStatTitle">
                    <span><a href={link}><button className="animLink animLink linkBorder" id={label}
                        >{label}</button></a></span>
                    </div>
                </div>
            </span>
        );
  }

  static uniqueDelegatesFormatter(cell, row) {
    if (!cell) {
      return "-";
    }

    return cell;
  }

  static formatPropData(cell, row) {
    if (!cell) {
      return "-";
    }

    return cell;
  }

  static activeAccountFormatter(cell, row) {
    if (!cell) {
      return "-";
    }

    return cell;
  }

  static formatGini(cell, row) {
    return <a className="animLink" href={constants.urls.giniExplanation}>{CoinUtils.btcValueFormatter(cell)}</a>;
  }

  static formatNakamoto(cell, row) {
    return <a className="animLink" href={constants.urls.nakamotoExplanation}>{cell}</a>;
  }
 
  static format24hTxs(cell, row) {
    if (row.tokenSymbol === "RUNE") {
      return "-";
    }
    console.log(row);
    return cell;
  }

  static format24hAddresses(cell, row) {
    if (row.tokenSymbol === "RUNE") {
      return "-";
    }
    console.log(row);
    return cell;
  }
}

export default NetworkUtils;



// WEBPACK FOOTER //
// ./src/network/NetworkUtils.js